import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import Modal from 'components/Sdk/Modal';
import { Button } from 'components';

const DeleteModal = ({ isPublished, message, onCancel, onDelete, title }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const removeButton = useRef();

  return (
    <Modal
      show
      color="danger"
      onCancel={onCancel}
      onOpened={() => {
        if (removeButton.current) {
          removeButton.current.focus();
        }
      }}
      size="sm"
      toggle={onCancel}
      footer={
        <Row>
          <Col xs="auto">
            <Button
              color="dark"
              icon={<FontAwesomeIcon icon={faTimes} />}
              onClick={onCancel}
              outline
              disabled={isDeleting}
            >
              Cancel
            </Button>
          </Col>
          <Col xs="auto">
            <Button
              autoFocus
              color="danger"
              icon={<FontAwesomeIcon icon={faTrashAlt} />}
              innerRef={removeButton}
              onClick={() => {
                setIsDeleting(true);
                onDelete();
              }}
              loading={isDeleting}
            >
              Yes, Delete
            </Button>
          </Col>
        </Row>
      }
    >
      <h3>
        {message ||
          (isPublished
            ? `“${title}” has launched.
            Deleting this send will stop the launch schedule.`
            : `Are you sure you want to delete “${title}” newsletter?`)}
      </h3>
    </Modal>
  );
};

DeleteModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  isPublished: PropTypes.bool,
};

DeleteModal.defaultProps = {
  title: null,
  message: null,
  onCancel: null,
  isPublished: false,
};

export default DeleteModal;
